export default __webpack_public_path__ + "static/media/Logo-Movie-Project-footer.ca1dbd2a.png";